export default __webpack_public_path__ + "static/media/ALLERGEN_GLUTEN.d997d94d.png";